import { IGroupHealthInsurancePoliciesInitialValues } from '../../../../types';

export const INITIAL_VALUES: IGroupHealthInsurancePoliciesInitialValues = {
  id: undefined,
  upload_files: [],
  start_date: '',
  end_date: '',
  policy_number: '',
  description: '',
  doc_type: '',
  organization: 0,
  recent_status: '',
};
